import { FaWhatsapp, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

export default function Footer() {
  const phone = "918438237072";
  const email = "megamindbusinesssolutions@gmail.com";

  return (
    <footer className="bg-black text-gray-400">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          
          {/* Brand */}
          <div>
            <h2 className="text-lg font-bold text-white">
              MegaMind<span className="text-green-500">.</span>
            </h2>
            <p className="mt-2 text-sm">
              Building modern digital solutions for businesses worldwide.
            </p>
            <div className="mt-3">
              <span className="text-xs bg-green-500/10 text-green-400 px-3 py-1 rounded-full">
                ✦ EMI Available
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#about" className="hover:text-green-400 transition">About</a></li>
              <li><a href="#services" className="hover:text-green-400 transition">Services</a></li>
              <li><a href="#projects" className="hover:text-green-400 transition">Projects</a></li>
              <li><a href="#pricing" className="hover:text-green-400 transition">Pricing</a></li>
              <li><a href="#contact" className="hover:text-green-400 transition">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>Web Development</li>
              <li>Mobile Apps</li>
              <li>E-Commerce</li>
              <li>UI/UX Design</li>
              <li>Maintenance</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">Contact</h3>
            <div className="space-y-2 text-sm">
              <p className="flex items-center gap-2">
                <FaPhoneAlt className="text-green-500" />
                <a href={`tel:${phone}`} className="hover:text-white transition">+91 {phone}</a>
              </p>
              <p className="flex items-start gap-2 break-all">
                <FaEnvelope className="text-blue-400 mt-0.5" />
                <a href={`mailto:${email}`} className="hover:text-white transition">{email}</a>
              </p>
              <a
                href={`https://wa.me/${phone}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 transition"
              >
                <FaWhatsapp />
                Chat on WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-10 pt-6 text-center text-xs text-gray-600">
          © {new Date().getFullYear()} MegaMind Business Solutions. All rights reserved.
        </div>
      </div>
    </footer>
  );
}